import React, { Component, Fragment } from 'react';
import Navbar from '../components/Navbar';
import Breadcrumbs from '../components/Breadcrumbs';
import MailingList from '../components/MailingList';
const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
};

export default class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { name: '', email: '', message: '', subject: '' };
  }

  /* Here’s the juicy bit for posting the form submission */

  handleSubmit = e => {
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'contact', ...this.state }),
    })
      .then(() => (window.location.href = '/thankyou'))
      .catch(error => alert(error));

    e.preventDefault();
  };

  handleChange = e => this.setState({ [e.target.name]: e.target.value });

  render() {
    const { name, email, message, subject } = this.state;
    return (
      <Fragment>
        <title>PropertyHints: Contact us</title>
        <Navbar />

        <div id="features">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <Breadcrumbs crumbs={[{ url: '/contact', name: 'Contact us' }]} />
                <h2 className="lead text-center">Flick us a message</h2>
                <hr />
                <div className="row">
                  <div className="col-sm-12 col-md-12">
                    <p>Want information about a topic we dont have? Email us, and we will see what we can do</p>
                  </div>
                  <div className="col-sm-12 col-md-12">
                    <form onSubmit={this.handleSubmit}>
                      <div className="controls controls-row">
                        <div className="col-sm-12 col-md-6 form-group">
                          <input
                            className="form-control"
                            placeholder="your name"
                            type="text"
                            name="name"
                            value={name}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="col-sm-12 col-md-6 form-group">
                          <input
                            className="form-control"
                            placeholder="your email"
                            type="email"
                            name="email"
                            value={email}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="controls controls-row">
                        <div className="col-sm-12 col-md-12 form-group">
                          <input
                            className="form-control"
                            placeholder="subject"
                            type="text"
                            name="subject"
                            value={subject}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="controls controls-row">
                        <div className="col-sm-12 col-md-12 form-group">
                          <textarea
                            className="form-control"
                            name="message"
                            value={message}
                            onChange={this.handleChange}
                            placeholder="I want to talk about... "
                            rows="5"
                          />
                        </div>
                        <div className="controls controls-row">
                          <div className="col-sm-12 col-md-12 form-group">
                            <button className="btn btn-primary" type="submit">
                              Send
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <hr />
                <MailingList />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Contact.jsx